import HTTP_PUBLIC from '@/config/axios-config-public'

const ServiceEcomplaintsPublic = {

  // Guarda la info de una nueva denuncia
  setComplaint(payload) {
    return HTTP_PUBLIC.post('ecanaldenuncias/setComplaint', payload).then(response => {
      return this.genericResponse(response)
    })
  },

  // Recupera la info general de una denuncia
  getComplaintData(payload) {
    return HTTP_PUBLIC.post('ecanaldenuncias/getComplaintData', payload).then(response => {
      return this.genericResponse(response)
    })
  },

  // Recupera la lista de tipos de denuncias
  getComplaintTypes(payload) {
    return HTTP_PUBLIC.post('ecanaldenuncias/getComplaintTypes', payload).then(response => {
      return this.genericResponse(response)
    })
  },

  // Lista gestores del canal (HRM_P_DEN) con usuario, nombre completo y email (oid)
  getManagersDen(payload) {
    return HTTP_PUBLIC.post('ecanaldenuncias/getManagersDen', payload).then(response => {
      return this.genericResponse(response)
    })
  },

  // Recupera los comentarios asociados a una denuncia
  getComplaintComments(payload) {
    return HTTP_PUBLIC.post('ecanaldenuncias/getComplaintComments', payload).then(response => {
      return this.genericResponse(response)
    })
  },


  // Guarda el comentario de una denuncia
  setComplaintComment(payload) {
    return HTTP_PUBLIC.post('ecanaldenuncias/setComplaintComment', payload).then(response => {
      return this.genericResponse(response)
    })
  }, 

  // Inserta un log de acceso a la denuncia
  setComplaintAccess(payload) {
    return HTTP_PUBLIC.post('ecanaldenuncias/setComplaintAccess', payload).then(response => {
      return this.genericResponse(response)
    })
  },

  // Recupera la lista de eventos/historial de una denuncia
  getComplaintLogs(payload) {
    return HTTP_PUBLIC.post('ecanaldenuncias/getComplaintLogs', payload).then(response => {
      return this.genericResponse(response)
    })
  }, 
  
  // Recupera la info de una denuncia anónima
  getAnonymComplaint(payload) {
    return HTTP_PUBLIC.post('ecanaldenuncias/getAnonymComplaint', payload).then(response => {
      return this.genericResponse(response)
    })
  },

  // Recupera los ficheros asociados a una denuncia
  getComplaintFiles(payload) {
    return HTTP_PUBLIC.post('ecanaldenuncias/getComplaintFiles', payload).then(response => {
      return this.genericResponse(response)
    })
  }, 

  // Recupera la url de descarga de un fichero
  getFileUrl(payload) {
    return HTTP_PUBLIC.post('ecanaldenuncias/getFileUrl', payload).then(response => {
      return this.genericResponse(response)
    })
  }, 

  // Añade ficheros a una denuncia ya introducida
  updateComplaintFiles(payload) {
    return HTTP_PUBLIC.post('ecanaldenuncias/updateComplaintFiles', payload).then(response => {
      return this.genericResponse(response)
    })
  },  

  // Añade ficheros a un plan de acción ya introducido
  updateTaskFiles(payload) {
    return HTTP_PUBLIC.post('ecanaldenuncias/updateTaskFiles', payload).then(response => {
      return this.genericResponse(response)
    })
  },  

  // Recupera la plantilla html para los ficheros de denuncia anónima o acuse de recibo 
  getComplaintPdf(payload) {
    return HTTP_PUBLIC.post('ecanaldenuncias/getComplaintPdf', payload).then(response => {
      return this.genericResponse(response)
    })
  }, 

  // Respuesta genérica para todos los servicios
  genericResponse (response) {
    if (response.status === 200 && response.data.result !== 'ko') {
      return response.data
    } else {
      console.error(response.status, response.data)
      throw response.data
    }
  }
}
export default ServiceEcomplaintsPublic
